module.exports = __webpack_public_path__ + "static/newyork-efac2e9cdd4507a0e40f0ee3c5b4590a.png";